const myStyle = require("./style.css")
export default {
    render(createElement) {
        let childElements = [];

        let closeButton = createElement("div", {
            on: {
                click: () => this.closePopup()
            },
            attrs: {
                class: "close-pop"
            }
        }, [
            createElement("svg", {
                attrs: {
                    width: "20",
                    height: "20",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
            }, [
                createElement("line", {
                    attrs: {
                        x1: "20", x2: "0", y1: "20", y2: "0", stroke: "white", "stroke-width": "1"
                    }
                }),
                createElement("line", {
                    attrs: {
                        x1: "0", x2: "20", y1: "20", y2: "0", stroke: "white", "stroke-width": "1"
                    }
                })
            ]
            )]);
        if (!this.forced) childElements.push(closeButton)
        let popupBody = createElement('div', {
            style: this.style(),
            class: this.open ? 'pop-box show' : 'pop-box',
        }, this.$slots.default)

        childElements.push(popupBody)
        childElements.push(createElement("style", {}, myStyle));
        if (this.value)
            return createElement(
                "div",
                {
                    on: {
                        click: ($event) => this.easyClose($event),
                        keydown: (event) => {
                            if (event.key == "Escape") {
                                this.closePopup()
                            }
                        }
                    },
                    attrs: {
                        class: this.open ? 'show bglfull bglpopup' : 'bglfull bglpopup',
                        style: this.bgColor ? 'background-color:' + this.bgColor : ''
                    }
                }, childElements
            );
    },
    props: {
        bgColor: String,
        title: String,
        width: String,
        type: String,
        value: [Object, String, Boolean],
        clickToClose: {
            type: Boolean,
            default: true,
        },
        forced: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: this.value,
        };
    },
    methods: {
        style() {
            var style = "";
            if (this.width) style += "width:90%;max-width:" + this.width + ";";
            if (this.type == "image") style += "background-color:transparent;";
            return style;
        },
        easyClose(e) {
            if (e.target.classList.contains("show") && this.clickToClose) {
                this.closePopup();
            }
        },
        closePopup() {
            if (this.forced) return;
            this.open = false;
            var emitValue = "";
            if (typeof this.value == "boolean") emitValue = false;
            setTimeout(() => this.$emit("input", emitValue), 200);
        },
        create() {
            setTimeout(() => (this.open = true), 10);
        },
    },
    mounted() {

    },
    watch: {
        value() {
            if (this.value) {
                setTimeout(() => (this.open = true), 10);
            } else {
                this.open = false;
            }
        },
    },
};
